import { render, staticRenderFns } from "./RobotForging.vue?vue&type=template&id=745ff6ae&scoped=true&"
import script from "./RobotForging.vue?vue&type=script&lang=js&"
export * from "./RobotForging.vue?vue&type=script&lang=js&"
import style0 from "./RobotForging.vue?vue&type=style&index=0&id=745ff6ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745ff6ae",
  null
  
)

export default component.exports